module.exports = __webpack_public_path__ + "img/handraw_plus orange.33f234db.svg";